import type { ReactNode } from 'react'
import { Header } from '../components/Header'

/** A full-page calm message: sign-in, not listed, loading, errors. */
export function Screen({ title, children, action, quiet }: { title: string; children?: ReactNode; action?: ReactNode; quiet?: boolean }) {
  return (
    <>
      <Header showNav={false} />
      <main className="page">
        <section className={`sheet screen-msg${quiet ? ' quiet' : ''}`}>
          <h1>{title}</h1>
          {children && <p className="lede">{children}</p>}
          {action && <div className="row-btns">{action}</div>}
        </section>
      </main>
    </>
  )
}
